module.exports = __webpack_public_path__ + "img/bg-4@1x.1eb50d09.png";